import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const LimitModal = ({ 
  open, 
  onClose, 
  userPlan 
}) => {
     const navigate = useNavigate();
  if (!open) return null;


  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Limit Exceeded
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {userPlan?.no_of_properties_unlimited 
            ? "You have unlimited access to properties."
            : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
               Please upgrade your subscription plan for more.`
          }
        </Typography>
         <Stack direction="row" spacing={2} justifyContent="center">
          <Button 
            variant="outlined" 
            color="primary"
            onClick={() => onClose()}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => {
              onClose();
              navigate('/user-subscription');
            }}
          >
            Upgrade
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default LimitModal;